export const config = {
    'apiUrl':'https://goodel.com.ua/commerce/',
    'assetsPrfix': 'https://goodel.com.ua/shop/files/',
    'siteUrl': 'https://goodel.com.ua/'
}